<template>
  <v-card class="overflow-hidden">
    <!-- A general bar -->
    <v-app-bar app color="#4862ab" dark elevate-on-scroll scroll-target="#page">
      <v-toolbar-title>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <v-btn text class="titleLabel" @click="goHome">(m)othertongues</v-btn>
            </v-list-item-title>
            <v-list-item-subtitle>How people live in a multiple language background</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <MENU v-for="(item, i) in categoryList" :key="i" :category="item" />
    </v-app-bar>

    <!-- Content Part -->
    <v-content>
      <v-sheet id="page" class="overflow-y-auto">
        <v-container fluid pb-0 pl-0 pr-0 pt-0>
          <router-view />
        </v-container>
        <v-footer padless color="#4862ab" dark>
          <v-card class="flex" flat tile color="#4862ab" dark>
            <v-card-title>
              <strong class="subheading">Connected with us on social media!</strong>

              <v-spacer></v-spacer>
              <a href="https://www.instagram.com/m.othertonguesmagazine/">
                <v-icon>mdi-instagram</v-icon>
              </a>
            </v-card-title>

            <v-card-text class="py-2 white--text text-lg-center">
              &copy; {{ new Date().getFullYear() }} —
              <strong>Bennington College</strong>
            </v-card-text>
          </v-card>
        </v-footer>
      </v-sheet>
    </v-content>
  </v-card>
</template>

<script>
import MENU from "./Menu.vue";
export default {
  components: {
    MENU
  },
  data: () => ({
    categoryList: [
      {
        title: "About",
        name: "About",
        subCat: [
          {
            title: "Contact",
            name: "Contact"
          },
          {
            title: "Call for Submission",
            name: "CFS"
          }
        ]
      },
      {
        title: "Writing",
        name: "Writing",
        subCat: [
          {
            title: "Poetry",
            name: "Poetry",
            articleList: {
              article1: {
                author: {
                  name: "Hafsa Zulfiqar",
                  title: "",
                  bio: ""
                },
                link: "the-one-who-was-named-before-his-birth",
                title: "the one who was named before his birth",
                items: [require("@/assets/Poetry/poetryPlaceHolder.jpg")]
              },
              article2: {
                author: {
                  name: "Michalina Aniol",
                  title: "",
                  bio: ""
                },
                link: "warsaw",
                title: "WARSAW",
                items: [require("@/assets/Poetry/Michalina_Aniol/image1.jpg")]
              },
              article3: {
                author: {
                  name: "Zanna Huth",
                  title: "",
                  bio: ""
                },
                link: "one-language-is-never-enough",
                title: "One language is never enough",
                items: [require("@/assets/Poetry/Zanna_Huth/pic1.png")]
              },
              article4: {
                author: {
                  name: "Domenica Montano",
                  title: "",
                  bio: ""
                },
                link: "the-troubling-journey-of-a-name-in-the-u-s",
                title: "The troubling journey of a name in the U.S.",
                items: [require("@/assets/Poetry/poetryPlaceHolder.jpg")]
              },
              article5: {
                author: {
                  name: "Valeria Sibrian Quijada",
                  title: "",
                  bio: ""
                },
                link: "hermanos-lejanos",
                title: "Hermanos Lejanos",
                items: [require("@/assets/Poetry/Valeria_Quijada/image1.png")]
              }
            }
          },
          {
            title: "Prose",
            name: "Prose",
            articleList: {
              article1: {
                author: {
                  name: "Soumya Rachel Shailendra",
                  title: "",
                  bio:
                    "Soumya Rachel Shailendra is a student of literature and politics at Bennington College. Her scholarly interests are centered around translation studies, resistance literature, and migration studies. She has previously collaborated with the National School of Drama, New Delhi. She is currently translating Dharamavir Bharati’s verse play, Andha Yug (1962) in English."
                },
                link: "an-elegy-for-my-mothers-tongue",
                title: "An Elegy for my Mother's Tongue",
                items: [require("@/assets/Prose/prosePlaceHolder.jpg")]
              },
              article2: {
                author: {
                  name: "Juan Lopez",
                  title: "",
                  bio: ""
                },
                link: "a-documentation-of-youth",
                title: "A Documentation of Youth",
                items: [require("@/assets/Prose/Juan_Lopez/image1.png")]
              }
            }
          }
        ]
      },
      {
        title: "Visual Arts",
        name: "VA",
        subCat: [
          {
            title: "Video",
            name: "Video",
            articleList: {
              article1: {
                author: {
                  name: "Alyssa Pong",
                  title: "",
                  bio: ""
                },
                link: "i-dont-know-what-to-say",
                title: "I Don't Know What to Say",
                items: [
                  require("../../assets/Alyssa/pic1.png"),
                  require("../../assets/Alyssa/pic2.png"),
                  require("../../assets/Alyssa/pic3.png"),
                  require("../../assets/Alyssa/pic4.png")
                ]
              },
              article2: {
                author: {
                  name: "Jonathan Lee",
                  title: "",
                  bio: ""
                },
                link: "how-to-make-kimchi-or-how-to-be-korean",
                title: "How To Make Kimchi or How to be Korean ",
                items: [require("@/assets/VA/Videos/Jonathan_Lee/image1.png")]
              },
              article3: {
                author: {
                  name: "Ayesha Bashir",
                  title: "",
                  bio:
                    "I am Ayesha Bashir from Karachi, Pakistan. I studied sciences for most of my life. Coming from a conventional middle-class family I wasn’t allowed to study the arts. I discovered my love for the arts in my senior year of high school. To me, making films is a way of survival. My work deals with topics like diaspora, alienation, and the universality of emotions."
                },
                link: "0-28",
                title: "0:28",
                items: [require("@/assets/VA/Videos/Ayesha_Bashir/image1.png")]
              }
            }
          },
          {
            title: "Film",
            name: "Film"
          },
          {
            title: "Animation",
            name: "Animation"
          },
          {
            title: "Photography",
            name: "Photography",
            articleList: {
              article1: {
                author: {
                  name: "Reshavan Naicker",
                  title: "",
                  bio:
                    "Reshavan Naicker was born and raised in Post-Apartheid South Africa. Growing up, his Indian heritage played a defining role in his upbringing. This created a complicated understanding of how nationality and ethnicity form parts of one’s identity. He left home at the age of 16 to attend the United World College of Costa Rica, where he was first exposed to — and discovered his love for — the visual arts. He is currently a sophomore at Bennington College where he is focussing in critical theory explored through his passions: photography, printmaking, and architecture. Reshavan’s cosmopolitan viewpoint allows him to expand his inquiries and investigate topics that are larger than himself, such as the oppositional gaze, postcolonialism, and race. "
                },
                link: "the-price-of-being-captured",
                title: "The Price of Being Captured",
                items: [
                  require("@/assets/VA/Photography/Reshavan_Naicker/1.jpg"),
                  require("@/assets/VA/Photography/Reshavan_Naicker/2.jpg"),
                  require("@/assets/VA/Photography/Reshavan_Naicker/3.jpg"),
                  require("@/assets/VA/Photography/Reshavan_Naicker/4.jpg"),
                  require("@/assets/VA/Photography/Reshavan_Naicker/5.jpg")
                ]
              },
              article2: {
                author: {
                  name: "Xiao Ma",
                  title: "",
                  bio: ""
                },
                link: "the-only-virus-present-is-your-racism",
                title: "The only virus present is your racism ",
                items: [
                  require("@/assets/VA/Photography/Xiao_Ma/1.jpg"),
                  require("@/assets/VA/Photography/Xiao_Ma/2.jpg"),
                  require("@/assets/VA/Photography/Xiao_Ma/3.jpg"),
                  require("@/assets/VA/Photography/Xiao_Ma/4.jpg"),
                  require("@/assets/VA/Photography/Xiao_Ma/5.jpg"),
                  require("@/assets/VA/Photography/Xiao_Ma/6.jpg")
                ]
              }
            }
          },
          {
            title: "Painting, Drawing & Sculpture",
            name: "PDS",
            articleList: {
              article1: {
                author: {
                  name: "Kale Eposito",
                  title: "",
                  bio: ""
                },
                link: "4-yellow-windows",
                title: "4 Yellow Windows",
                items: [require("@/assets/VA/PDS/Kale_Esposito/image1.jpg")]
              },
              article2: {
                author: {
                  name: "Melih Meric",
                  title: "",
                  bio:
                    "Melih is a third year student at Bennington College, focusing his studies on Visual Arts, mainly printmaking and islamic art history. He is a 2017 graduate from United World College Maastricht and has participated in as an artist and as an assistant curator to exhibitions throughout his experience in Turkey, the Netherlands and the United States. "
                },
                link: "3-printmaking-pieces",
                title: "3 printmaking pieces",
                items: [
                  require("@/assets/VA/PDS/Melih_Meric/lamp.png"),
                  require("@/assets/VA/PDS/Melih_Meric/midnight.png"),
                  require("@/assets/VA/PDS/Melih_Meric/pattern.jpg")
                ]
              }
            }
          }
        ]
      },
      {
        title: "Performance Arts",
        name: "PA",
        subCat: [
          {
            title: "Music",
            name: "Music"
          },
          {
            title: "Scripts",
            name: "Scripts"
          },
          {
            title: "Dance",
            name: "Dance"
          },
          {
            title: "Drama",
            name: "Drama"
          },
          {
            title: "Podcast",
            name: "Podcast",
            articleList: {
              article1: {
                author: {
                  name: "Andreea Coscai",
                  title: "",
                  bio: ""
                },
                link: "whose-choice-is-my-choice",
                title: "Whose Choice is My Choice",
                items: [
                  require("@/assets/PA/Podcast/Andreea_Coscai/image1.png")
                ]
              }
            }
          }
        ]
      }
    ]
  }),
  methods: {
    goHome: function() {
      this.$router.push({ name: "Home" });
    }
  }
};
</script>

<style scoped>
.titleLabel {
  text-transform: none !important;
}
</style>